export const getReadableWarning = (warning) => {
  if (warning.headline) {
    return `${warning.headline}: ${warning.detail}`
  }
  return `${warning.detail}`
}
